import { FC } from 'react';
import styled from 'styled-components';
import { UIModal } from '@/components/ui/Modal';
import { Typography } from '@/components/ui/Typography';
import { UIBox } from '@/components/ui/Box';
import { UIButton } from '@/components/ui/Button';
import { useTranslation } from 'react-i18next';

export interface ModalInfoProps {
  open: boolean;
  title?: string;
  subtitle?: string;
  message?: string;
  content?: JSX.Element;
  onConfirmClick?: () => Promise<void> | void;
  onBackClick?: () => Promise<void> | void;
  onClose: () => void;
  disableConfirm?: boolean;
  loadingConfirm?: boolean;
}

//#region - Styled Components
const StyledWrapper = styled(UIBox)`
  width: 100%;
  padding: 24px;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

const StyledContent = styled(UIBox)`
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

const StyledMessageWrapper = styled(UIBox)`
  margin: 18px 0 32px;

  span {
    line-height: 19px !important;
  }
`;

const SyledButtonContainer = styled(UIBox)`
  align-items: center;
  gap: 43px;
  width: 60%;
  align-self: flex-end;
`;
//#endregion

const ModalInfo: FC<ModalInfoProps> = ({
  open,
  title,
  subtitle,
  message,
  content,
                                         onClose,
  onConfirmClick,
  onBackClick,
  disableConfirm,
  loadingConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <UIModal
      $minWidth="300px"
      $minHeight="225px"
      $maxWidth="500px"
      open={open}
      onClose={onClose}
    >
      <StyledWrapper>
        <StyledContent>
          <Typography font="heavy" size={'md'}>
            {title || t('payAttention')}
          </Typography>
          <Typography font="medium" size={'sm'}>
            {subtitle || t('payAttention')}
          </Typography>
          <StyledMessageWrapper>
            {message && <Typography>{message}</Typography>}
            {content && content}
          </StyledMessageWrapper>
          <SyledButtonContainer>
            <UIButton
              label={t('back')}
              onClick={onBackClick || onClose}
              errorStyle={true}
              outlined={true}
            />
            <UIButton
              label={t('continue')}
              loading={loadingConfirm}
              onClick={onConfirmClick}
              disabled={disableConfirm}
            />
          </SyledButtonContainer>
        </StyledContent>
      </StyledWrapper>
    </UIModal>
  );
};

export default ModalInfo;
